import { metrics } from '@atlassian/browser-metrics';

// https://perfportal.prod.atl-paas.net/experience/identity.fe.inline-result.aid-frontend-recaptcha-fetch-token-check-username/
export const recaptchaCheckUsernameFetchTokenInteraction = metrics.interaction({
  key: 'aid-frontend-recaptcha-fetch-token-check-username',
});
